$(function () {
$('.slide1,.slide2').slick({
    fade: true,    // fedeオン
    speed: 2500,   // 画像切り替えにかかる時間（ミリ秒）
    autoplaySpeed: 3000,   // 自動スライド切り替え速度
    arrows: false,         // 矢印表示・非表示
    autoplay: true,        // 自動再生
    slidesToShow: 1,       // スライド表示数
    slidesToScroll: 1,     // スライドする数
    infinite: true,         // 無限リピート オン・オフ
    swipe: false
  });
$('.slider-review').slick({
		autoplay: true,//自動的に動き出すか。初期値はfalse。
		autoplaySpeed: 6000,//次のスライドに切り替わる待ち時間
		speed:1000,//スライドの動きのスピード。初期値は300。
		infinite: true,//スライドをループさせるかどうか。初期値はtrue。
		slidesToShow: 1,//スライドを画面に2枚見せる
		slidesToScroll: 1,//1回のスクロールで3枚の写真を移動して見せる
        pauseOnFocus: false,//フォーカスで一時停止を無効
        pauseOnHover: false,//マウスホバーで一時停止を無効
        pauseOnDotsHover: false,//ドットナビゲーションをマウスホバーで一時停止を無効
        swipe: false,
});
 });


